var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuizQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 883,
    height: 406,
    viewBox: "0 0 883 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 79H810V339H81V79Z",
    fill: "url(#paint0_linear_9_2)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 105,
    width: 19,
    height: 209,
    fill: "#9787D8",
    fillOpacity: 0.46
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 88,
    width: 652,
    height: 17,
    fill: "#9787D8",
    fillOpacity: 0.38
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 8,
    height: 70,
    fill: "#2C3261"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 282,
    width: 8,
    height: 70,
    fill: "#2C3261"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 66,
    width: 8,
    height: 70,
    fill: "#2C3261"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 282,
    width: 8,
    height: 70,
    fill: "#2C3261"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 66,
    width: 50,
    height: 9,
    fill: "#2C3261"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 343,
    width: 50,
    height: 9,
    fill: "#2C3261"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 66,
    width: 50,
    height: 9,
    fill: "#2C3261"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 767,
    y: 343,
    width: 50,
    height: 9,
    fill: "#2C3261"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207.316 395.75L240.631 339H193L207.316 395.75Z",
    fill: "#463B88"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_2",
    x1: 445.5,
    y1: 79,
    x2: 445.5,
    y2: 339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A67EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#493E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463B88"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizQuestion);
export default __webpack_public_path__ + "static/media/quiz-question.69b21d658781f0a5a4a88b1a68b14154.svg";
export { ForwardRef as ReactComponent };